<div>
  <iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>

<div *ngIf="!addCardBool && !updateCardBool && !updateAchBool" class="container-fluid">

  <div class="row">
    <button class="btn btn-primary col-auto px-4 mb-2" (click)="displayAddPaymentMethod()">Add Payment Method</button>
  </div>

  <div class="row">
    <div class="col-12">
      <p-table styleClass="p-datatable-striped" #paymentTable [columns]="tableColumn" [value]="paymentMethods" [scrollable]="true" scrollHeight="50vh" dataKey="uniqueId"
        expandableRows="true">
        <ng-template pTemplate="header" let-columns>
          <tr *ngIf="paymentMethods.length > 0">
            <th class="small-column-flex-override"></th>
            <th *ngFor="let col of columns" class="noBorder">
              {{col.header}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
          <tr>
            <td class="small-column-flex-override">
              <button type="button" pButton pRipple [pRowToggler]="rowData" class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'fas fa-minus' : 'fas fa-plus'">
              </button>
            </td>
            <td *ngFor="let col of columns" class="noBorder truncate" [ngSwitch]="col.field">

              <div *ngSwitchCase="'cardType'">
                {{rowData[col.field] | creditCard}}
              </div>

              <div *ngSwitchCase="'accountNumber'">
                Ending in {{rowData.lastFourDigits}}
              </div>

              <div *ngSwitchCase="'expDate'">
                <span class="redFont" *ngIf="isDateExpired(rowData.expirationMonth,rowData.expirationYear)">Expired</span>
                <span *ngIf="rowData.expirationMonth" [ngClass]="isDateExpired(rowData.expirationMonth,rowData.expirationYear)">
                  {{rowData.expirationMonth | number:'2.0'}}/{{rowData.expirationYear}}
                </span>
                <span *ngIf="!rowData.expirationMonth">N/A</span>

              </div>
              <div *ngSwitchCase="'default'">
                <span *ngIf="(rowData.default === false || rowData.default === undefined) && rowData.cardType === 'ACH'">
                  <a href="javascript:void(0)" (click)="setAsDefaultAch(rowData)">Set as default</a>
                </span>
                <span *ngIf="(rowData.default === false || rowData.default === undefined) && rowData.cardType !== 'ACH'">
                  <a href="javascript:void(0)" (click)="setAsDefaultCard(rowData)">Set as default</a>
                </span>
                <span *ngIf="rowData.default === true">Default</span>
              </div>
              <div *ngSwitchCase="'edit'">
                <span *ngIf="rowData.cardType !== 'ACH'">
                  <a href="javascript:void(0)" (click)="cardToEdit(rowData)">Edit</a>
                </span>
                <span *ngIf="rowData.cardType === 'ACH'">
                  <a href="javascript:void(0)" (click)="achToEdit(rowData)">Edit</a>
                </span>
              </div>

              <div *ngSwitchCase="'remove'">
                <span *ngIf="rowData.cardType !== 'ACH'">
                  <a href="javascript:void(0)" (click)="removeCreditCard(rowData)">Remove</a>
                </span>
                <span *ngIf="rowData.cardType === 'ACH'">
                  <a href="javascript:void(0)" (click)="removeAch(rowData)">Remove</a>
                </span>
              </div>

              <div *ngSwitchDefault class="truncate" [pTooltip]="rowData[col.field] ? rowData[col.field]: ''" tooltipPosition="top" appShowToolTipIfTruncated>{{rowData[col.field]}}
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-rowData>
          <tr>
            <td colspan="7" class="align-items-start">
              <div class="row">
                <div class="col-4">
                  <span *ngIf="rowData.accountOwnerName"><span class="fw-bold">Account Owner Name: </span>{{ rowData.accountOwnerName }}</span>
                  <span *ngIf="rowData.firstName"><span class="fw-bold">Cardholder Name: </span>{{ rowData.firstName + ' ' + rowData.lastName }}</span>
                </div>
                <div class="col-5" *ngIf="rowData.address1">
                  <div class="row">
                    <div class="col-4">
                      <span class="fw-bold">Street Address: </span>
                    </div>
                    <div class="col-6">
                      <div class="row">
                        {{rowData.address1}}
                      </div>
                      <div class="row" *ngIf="rowData.address2">{{rowData.address2}}</div>
                      <div class="row">
                        {{rowData.city}},&nbsp;{{rowData.state}}&nbsp;{{rowData.zip}}&nbsp;
                      </div>
                      <div class="row">
                        {{rowData.country | scrConfig:'country'}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4" *ngIf="rowData.routingNumber">
                  <span *ngIf="rowData.accountType"><span class="fw-bold">Account Type:
                    </span> {{ rowData.accountType | pmAccountType }}</span><br>
                  <span *ngIf="rowData.routingNumber"><span class="fw-bold">Routing
                      Number:
                    </span>{{ rowData.routingNumber }}</span><br>
                  <span *ngIf="rowData.bankName"><span class="fw-bold">Bank Name:
                    </span>{{
                    rowData.bankName }}</span>
                </div>
                <div class="col-4" *ngIf="rowData.limit">
                  <span *ngIf="rowData.accountType"><span class="fw-bold">Maximum Payment
                      Limit:
                    </span>{{ rowData.limit | currency }}</span>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="noBorder">
              <b>There are currently no payment methods listed in your account.</b>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>


  </div>
</div>

<div *ngIf="addCardBool" class="container-fluid">
  <app-add-payment [hasDefault]="hasDefault" (emitAction)="receiveChildEvent($event)"></app-add-payment>
</div>

<div *ngIf="updateCardBool" class="container-fluid">
  <app-update-card [hasDefault]="hasDefault" (emitAction)="receiveChildEvent($event)" [card]="cardToEditObj">
  </app-update-card>
</div>

<div *ngIf="updateAchBool" class="container-fluid">
  <app-update-ach (emitAction)="receiveChildEvent($event)" [ach]="achToEditObj"></app-update-ach>
</div>

<p-confirmDialog key='confirmDelete' #confirmDelete width="425" [closable]="false">
  <p-footer>
    <div class="d-flex justify-content-end">
      <button i18n id="scaccept" class="btn btn-primary me-2" (click)="confirmDelete.accept()">OK</button>
      <button i18n id="screject" class="btn btn-secondary" (click)="confirmDelete.reject()">Cancel</button>
    </div>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog key='confirmDefault' #confirmDefault width="425" [closable]="false">
  <p-footer>
    <div class="d-flex justify-content-end">
      <button i18n id="scaccept" class="btn btn-primary me-2" (click)="confirmDefault.accept()">OK</button>
      <button i18n id="screject" class="btn btn-secondary" (click)="confirmDefault.reject()">Cancel</button>
    </div>
  </p-footer>
</p-confirmDialog>